import React from "react";
import "../../Form/components/FormLegend.scss";
// can't apply styles directly to legend USWDS
const styles = {
  marginTop: "30px",
};

const Legend = (props) => (
  <div style={styles}>
    <legend className={`usa-legend`} style={styles} {...props}>
      {props.children}
    </legend>
  </div>
);

export default Legend;
